import React, { useState } from 'react';
import { api, auth } from '../api/client';

export default function Login({ onAuthed }) {
  const [step, setStep] = useState('mobile'); // 'mobile' | 'register'
  const [mobile, setMobile] = useState('');
  const [pin, setPin] = useState('');
  const [reg, setReg] = useState({
    name: '', companyName: '', clientLocation: '', altMobile: '', email: '',
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const validMobile = /^\d{10}$/.test(mobile);

  async function submitLogin() {
    setError('');
    if (!validMobile) { setError('Enter a valid 10-digit mobile number.'); return; }
    setBusy(true);
    try {
      const resp = await api.login({ mobile, pin });
      if (resp?.needsRegistration) {
        setStep('register'); // new number — collect details
      } else {
        auth.save(resp);
        onAuthed(resp);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  async function submitRegister() {
    setError('');
    if (!reg.name.trim() || !reg.companyName.trim() || !reg.clientLocation.trim()) {
      setError('Name, company and location are required.');
      return;
    }
    setBusy(true);
    try {
      const resp = await api.login({ mobile, pin: '', ...reg });
      auth.save(resp);
      onAuthed(resp); // new accounts come back with mustResetPin = true
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app-shell">
      <div className="center-stack">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div className="logo" style={{
            width: 60, height: 60, margin: '0 auto 14px', borderRadius: 18,
            fontSize: 30, display: 'grid', placeItems: 'center', color: '#fff',
            background: 'linear-gradient(135deg, var(--sky-400), var(--sky-600))',
            boxShadow: '0 8px 24px rgba(2,132,199,.4)',
          }}>◎</div>
          <h1>Smart Vision</h1>
          <p className="muted">Service ticket portal</p>
        </div>

        {step === 'mobile' && (
          <div className="card">
            <div className="field">
              <label className="label">Mobile number</label>
              <input
                className="input" inputMode="numeric" maxLength={10}
                placeholder="10-digit mobile" value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
                autoComplete="tel"
              />
            </div>
            <div className="field">
              <label className="label">PIN <span className="faint">(first time: 1234)</span></label>
              <input
                className="input pin-input" inputMode="numeric" maxLength={4}
                type="password" placeholder="••••" value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
              />
            </div>
            <button className="btn btn-primary" disabled={busy} onClick={submitLogin}>
              {busy ? <span className="spinner" /> : 'Continue'}
            </button>
            {error && <p className="error-text">{error}</p>}
            <p className="faint" style={{ marginTop: 12, textAlign: 'center' }}>
              New number? Just continue — we'll register you.
            </p>
          </div>
        )}

        {step === 'register' && (
          <div className="card">
            <h2 style={{ marginBottom: 4 }}>Create your account</h2>
            <p className="muted" style={{ marginBottom: 16 }}>
              Mobile {mobile} is new. A few details to get started.
            </p>
            <div className="field">
              <label className="label">Your name *</label>
              <input className="input" value={reg.name}
                onChange={(e) => setReg({ ...reg, name: e.target.value })} />
            </div>
            <div className="field">
              <label className="label">Company name *</label>
              <input className="input" value={reg.companyName}
                onChange={(e) => setReg({ ...reg, companyName: e.target.value })} />
            </div>
            <div className="field">
              <label className="label">Site / location *</label>
              <input className="input" placeholder="e.g. Pune – Hinjewadi" value={reg.clientLocation}
                onChange={(e) => setReg({ ...reg, clientLocation: e.target.value })} />
            </div>
            <div className="field">
              <label className="label">Alternate mobile <span className="faint">(optional)</span></label>
              <input className="input" inputMode="numeric" maxLength={10} value={reg.altMobile}
                onChange={(e) => setReg({ ...reg, altMobile: e.target.value.replace(/\D/g, '') })} />
            </div>
            <div className="field">
              <label className="label">Email <span className="faint">(optional)</span></label>
              <input className="input" type="email" value={reg.email}
                onChange={(e) => setReg({ ...reg, email: e.target.value })} />
            </div>
            <button className="btn btn-primary" disabled={busy} onClick={submitRegister}>
              {busy ? <span className="spinner" /> : 'Register & continue'}
            </button>
            {error && <p className="error-text">{error}</p>}
            <button className="btn btn-ghost" style={{ marginTop: 10 }}
              onClick={() => { setStep('mobile'); setError(''); }}>
              Back
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
